<script>
  import AwEmailValidation from '~~/common/components/Page/Account/AwEmailValidation';
  export default AwEmailValidation;
</script>
